export default class CreateLocationError extends Error {

}